<template>
    <modal root-id="update-password-reminder" root-classes="modal show" modal-width="modal-md" :ignore-escape="true">
        <template #modal-container>
            <img src="/images/password.png" class="h-28 mx-auto mt-8" alt="Imagen de crear contraseña" />
            <h6 class="text-3xl font-semibold text-center leading-tight mt-5">
                Es necesario que crees tu contraseña personal
            </h6>
            <p class="text-center mt-4">
                Para continuar disfrutando de todos los beneficios de una manera más segura actualiza tu contraseña.
            </p>
            <div class="flex justify-center mt-6">
                <button
                    @click.prevent="openUpdatePasswordFormModal"
                    class="btn btn-green sm:inline-block block sm:w-auto w-full px-6 py-3"
                >
                    Crear mi nueva contraseña
                </button>
            </div>
            <p class="text-sm text-center mt-6">
                Recuerda que tu periodo de prueba termina el:
                <strong class="block text-center">{{ trialEndsAt }}</strong>
            </p>
        </template>
    </modal>
</template>

<script>
import Modal from './Modal';
import moment from 'moment';

export default {
    components: {
        Modal,
    },

    props: ['plan'],

    data() {
        return {
            trialEndsAt: moment().add(15, 'days').format('D [de] MMMM, Y'),
        };
    },

    methods: {
        openUpdatePasswordFormModal() {
            this.$emit('createPasswordButtonPressed');
        },
    },
};
</script>
